export default "/fonts/UkNumberPlate.woff2?32cf935f68538e624596fa65b054b89d";